import React from 'react';
import { connect } from 'react-redux';

import { requestPasswordReset, reset } from '../../../../redux/auth/requestPasswordReset/actions';
import { selectLoading, selectError, selectErrorMessage } from '../../../../redux/auth/requestPasswordReset/selectors';

import ForgotPasswordModal from './ForgotPasswordModal';

const ForgotPasswordModalConnected = (props) => <ForgotPasswordModal {...props} />;

const mapDispatchToProps = (state) => ({
  isLoading: selectLoading(state),
  error: selectError(state),
  errorMessage: selectErrorMessage(state),
});

const mapActionsToProps = {
  requestPasswordReset,
  reset,
};

export default connect(mapDispatchToProps, mapActionsToProps)(ForgotPasswordModalConnected);
